import { render, staticRenderFns } from "./SelectSpeciality.vue?vue&type=template&id=7bb3f57f&scoped=true"
import script from "./SelectSpeciality.vue?vue&type=script&lang=js"
export * from "./SelectSpeciality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb3f57f",
  null
  
)

export default component.exports